const { isStringValid, endsWithPunctuation } = require("simpul");
const dictionaryConfig = require("../dictionary.index").get("description");
const { stripHtml } = require("string-strip-html");
const regex = require("../regex");

function makeDescriptionLabel({ description, ...rest }) {
  if (isStringValid(description)) {
    const cleanDescription = description
      .trim()
      .slice(0, dictionaryConfig.maxLength + 5)
      .trim();

    return cleanDescription;
  } else {
    const richTextKeys = [
      "rich_text_story_substring",
      "rich_text_story",
      "comment_text",
    ];

    for (let i = 0; i < richTextKeys.length; i++) {
      let richText = rest[richTextKeys[i]];

      if (isStringValid(richText)) {
        let text = stripHtml(richText).result.trim();

        let cleanText = text
          .slice(0, dictionaryConfig.maxLength)
          .trim()
          .replace(regex.endsWithTag.r, "")
          .trim();

        const appendEllipses =
          text.length >= dictionaryConfig.maxLength &&
          !endsWithPunctuation(cleanText);

        if (appendEllipses) cleanText += "...";

        return cleanText;
      }
    }
  }
}

module.exports = makeDescriptionLabel;
